/**
 * Enum for agency identifier kind
 * @enum {string}
 * @readonly
 */
export const AgencyIdentifierKind = Object.freeze({
  IATA: 'IATA',
  CLIA: 'CLIA',
  OTHER: 'OTHER',
});

/**
 * Map of agency identifier kinds to their human readable names
 * @type {Object.<string, string>}
 * @readonly
 */
export const AgencyIdentifierKindCopy = {
  [AgencyIdentifierKind.IATA]: 'IATA',
  [AgencyIdentifierKind.CLIA]: 'CLIA',
  [AgencyIdentifierKind.OTHER]: 'Other',
};

/**
 * Maximum number of agency identifiers returned in a single request.
 *
 * Pagination is not currently supported due to UX complexity. Most agencies
 * only have 1–3 identifiers, though one agency has more than 60, so this
 * limit is set high enough to cover all cases.
 *
 * @type {number}
 * @readonly
 */
export const AgencyIdentifierPerPage = 20;
